<template>
    <div class="background" :class="['background--'+backgroundModifier, 'background--previous-'+backgroundPreviousModifier]">
        <div class="background__home"></div>
        <div class="background__denmark">
            <video 
            src="videos/dk-map.m4v?cb=3"
            class="denmark-map__layer-video"
            ref="dkVideo"
            muted
            autoplay
            loop
            playsinline
            webkit-playsinline
            type="video/mp4"
            @contextmenu.prevent=""></video>
        </div>
        <div class="background__denmark-case"></div>
        <div class="background__europe"> 
        </div>
        <div class="background__europe-case"></div>
    </div>
</template>


<script>
    import store from '../dataStore';
    import eventBus from '@/helpers/eventBus';

    export default {
        name: 'Background',
        props: {
            backgroundModifier: String,
        },
        data()
        {
            return({
                backgroundPreviousModifier: 'none'
            });
        },
        watch: {
    backgroundModifier(newValue, oldValue) {
        this.backgroundPreviousModifier = oldValue;

        if (oldValue === 'denmark' || oldValue === 'denmark-case' || oldValue === "none") return;

        let transitionDurationMs = newValue === 'europe' ? 500 : 1500; // Use shorter duration for fade effect

        clearTimeout(this.transitionTimeout);
        store.setBackgroundTransitionState(true);

        this.transitionTimeout = setTimeout(() => {
            store.setBackgroundTransitionState(false);
        }, transitionDurationMs);
    }
},
        mounted()
        {
            
            let video = this.$refs.dkVideo;

            this.events = {
                startVideo: ()=>{
                    video.play();
                },
                stopVideo: ()=>{
                    video.pause();
                },
            }
                        
            eventBus.on('background.startVideo', this.events.startVideo);
            eventBus.on('background.stopVideo', this.events.stopVideo);
        },
        unmounted()
        {
            eventBus.off('background.startVideo', this.events.startVideo);
            eventBus.off('background.stopVideo', this.events.stopVideo);
        }
    }
</script>